<template>
    <div>
        <v-card class="">
            <person-emergency-contacts-table :person-id="personId" />
        </v-card>
    </div>
</template>

<script>
    import PersonEmergencyContactsTable from '@/views/ManagePersonnel/components/PersonEmergencyContact/PersonEmergencyContactsTable';

    export default {


        name: "EmergencyContact",

        components: {
            PersonEmergencyContactsTable,
        },

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },
    }
</script>

<style scoped>
    #personEmergencyContacts {
        font-size: 14px;
        text-align: left;
    }
</style>
